import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import toast from "react-hot-toast";
import './EquipmentsManager.css'

const SUGGESTED_EQUIPMENTS = [
  "WiFi",
  "Piscine",
  "Climatisation",
  "Parking",
  "Spa",
  "Petit-déjeuner",
  "Salle de sport",
  "Navette aéroport",
  "Restaurant",
  "Bar",
  "Plage privée",
  "Vue sur mer"
];

export default function EquipmentsManager({ data, hotelId }) {
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestion, setSuggestion] = useState(null);
  const [equipments, setEquipments] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
  if (data?.equipments) {
    setEquipments(data.equipments);
  }
}, [data]);

const saveToBackend = async (updatedEquipments) => {
  await fetch(`https://api.komorotel.com/api/hotels/${hotelId}`, {
    method: "PUT",
    credentials: "include",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({
      equipments: updatedEquipments
    })
  });
};

  const handleAdd = async () => {

    if (!inputValue.trim()) return;

    // Séparer par virgule
    const newItems = inputValue
        .split(",")
        .map(item => item.trim())
        .filter(item => item !== "");

    if (newItems.length === 0) return;

    // Supprimer doublons
    const uniqueItems = newItems.filter(
        item => !equipments.includes(item)
    );

    if (uniqueItems.length === 0) {
        toast.error("Tous ces équipements existent déjà");
        return;
    }


    const updated = [...equipments, ...uniqueItems];

    setEquipments(updated);
    setInputValue("");

    await saveToBackend(updated);

    toast.success("Équipements ajoutés ✨");
    };
  const handleSelectSuggestion = async (item) => {
    const updated = [...equipments, item];

    setEquipments(updated);
    setInputValue("");
    setSuggestion(null); // 🔥 IMPORTANT

    await saveToBackend(updated);
    toast.success("Équipement ajouté ✨");
  };

  const handleDelete = async (item) => {
    const updated = equipments.filter(e => e !== item);
    setEquipments(updated);
    await saveToBackend(updated);
    toast.success("Équipement supprimé");
  };

  return (
    <div className="modern-card">

      <div className="section-title">Équipements</div>

      <div className="equipments-container">

        <AnimatePresence>
          {equipments.map(item => (
            <motion.div
              key={item}
              layout
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              className="equipment-tag"
            >
              {item}
              <button onClick={() => handleDelete(item)}>✕</button>
            </motion.div>
          ))}
        </AnimatePresence>

        
            <div className="equipment-input-wrapper">

                <input
                    type="text"
                    placeholder="Ajouter un équipement..."
                    value={inputValue}
                    onChange={(e) => {
                        const value = e.target.value;

                        // Si l'utilisateur tape une virgule
                        if (value.includes(",")) {

                            const parts = value.split(",");

                            const newItems = parts
                            .map(item => item.trim())
                            .filter(item => item !== "");

                            if (newItems.length > 0) {

                            const uniqueItems = newItems.filter(
                                item => !equipments.includes(item)
                            );

                            if (uniqueItems.length > 0) {

                                const updated = [...equipments, ...uniqueItems];

                                setEquipments(updated);
                                saveToBackend(updated);
                                toast.success("Équipements ajoutés ✨");
                            }
                            }

                            setInputValue("");
                            setSuggestion(null);
                            return;
                        }

                        setInputValue(value);

                        // suggestion subtile
                        if (!value.trim()) {
                            setSuggestion(null);
                            return;
                        }

                        const match = SUGGESTED_EQUIPMENTS.find(item =>
                            item.toLowerCase().startsWith(value.toLowerCase()) &&
                            !equipments.includes(item)
                        );

                        setSuggestion(match || null);
                    }}
                    onKeyDown={(e) => e.key === "Enter" && handleAdd()}
                    className="equipment-input"
                />

                {suggestion && (
                    <motion.div
                    className="inline-suggestion"
                    onClick={() => handleSelectSuggestion(suggestion)}
                    initial={{ opacity: 0, x: 10 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0 }}
                    >
                    + {suggestion}
                    </motion.div>
                )}

                <button
                className="add-btn"
                onClick={handleAdd}
            >
                +
            </button>

            </div>

            

        

      </div>

    </div>
  );
}